import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { IUserProfileDetails, IShipment } from 'types/Location'
import { getShipment } from 'utils/actions/shipment'
import { getUserProfileDetails } from 'utils/actions/user'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import useUserDetails from 'utils/hooks/useUserDetails'
import { CarrierInformation } from './CarrierInformation'
import { DetentionReviewMap } from './DetentionReviewMap'
import DetentionShipperAccessorialCard from './DetentionShipperAccessorialCard'
import Issues from './Issues'
import { Notes } from './Notes'
import { RequestForm } from './RequestForm'

interface IDetentionReviewStore {
  shipmentData: {
    shipment: IShipment
  }
  userProfile: {
    userProfileDetails: IUserProfileDetails
  }
}

interface IDetentionReviewState {
  shipment: IShipment
  userProfile: {
    userProfileDetails: IUserProfileDetails
  }
}

export const DetentionReview = () => {
  const state = useSelector<IDetentionReviewStore, IDetentionReviewState>(
    ({ shipmentData: { shipment }, userProfile }) => ({
      shipment,
      userProfile,
    })
  )
  const {
    shipment,
    shipment: { info: { driverId = undefined } = {} } = {},
    userProfile: { userProfileDetails = {} } = {},
  } = state
  const { accessorialId, shipmentId } = useParams<{ shipmentId: string; accessorialId: string }>()
  const dispatch = useDispatch()
  useEffect(() => {
    if (shipmentId && accessorialId) {
      dispatch(getShipment(shipmentId, '', true))
    }
  }, [shipmentId, accessorialId])

  // get user profile details for driver
  useEffect(() => {
    if (driverId) {
      dispatch(getUserProfileDetails(driverId))
    }
  }, [driverId])

  const { userPermissions } = useUserDetails()
  const canReviewDetention =
    userPermissions?.approveAccessorials && userPermissions?.rejectAccessorials

  const showIssues = useFeatureFlag('detentionPageShowIssues')
  const showAccessorial = useFeatureFlag('detentionPageShowAccessorialPolicy') && canReviewDetention

  // eslint-disable-next-line no-prototype-builtins
  const doesUserProfileDetailsExist = userProfileDetails?.hasOwnProperty('id')

  return shipment ? (
    <div className='container'>
      <div className='col-xs-12 col-md-6'>
        <RequestForm accessorialId={accessorialId} />
        <CarrierInformation />
        {showAccessorial && <DetentionShipperAccessorialCard />}
      </div>
      <div className='col-xs-12 col-md-6'>
        <div className='col-xs-12 col-md-12'>
          {doesUserProfileDetailsExist ? <DetentionReviewMap /> : 'No user profile details'}
        </div>
        {showIssues && <Issues shipmentId={shipmentId} />}
        <Notes />
      </div>
    </div>
  ) : (
    <div />
  )
}
